module.exports = __webpack_public_path__ + "img/indicate-app-email@2x.f09d20e.png";